/* Dynamic Plot code copyright 2024 (c) Tuva Labs Inc.
 *
 * created by cmiller
 */
import ReactDOM from "react-dom";
import CaseCard from "../../../components/elem-play/editable/CaseCard";

export default class CardView {
    constructor(Dyn, container) {
        // references to other objects
        this.Dyn = Dyn;
        this.container = container;

        // our stuff
        this.bounds = new Dyn.mathUtil.Rect(0, 0, 0, 0); // area where big cards are allowed
    }

    destroy() {
        this.Dyn = null;
        this.container = null;
        // Properly destroy this.outline and this.htmlRoot
        this.htmlRoot.unmount();
        this.outline.remove();
    }

    onChange = () => {
        // update home visuals to reflect newly added cases
        this.container.home?.updateVisuals();
    }

    initVisuals() {
        // Attribute card
        const rect = this.bounds;
        const outline = this.container.paper.foreignObject(
            "",
            rect.x,
            rect.y,
            rect.width,
            rect.height + 70
        );
        const body = outline.node.firstChild;
        body.style.height = "100%";
        const container = document.createElement("div");
        container.classList.add("tde-fill", "tde-bg-color");
        body.appendChild(container);
        // Render using react
        const root = ReactDOM.createRoot(container);
        root.render(<CaseCard ref={(ele) => this.caseCardRef = ele} Dyn={this.Dyn} onChange={this.onChange} />);

        this.outline = outline;
        this.htmlRoot = root;
        this.updateVisuals();
    }

    updateVisuals(caseIndex) {
        const rect = this.bounds;
        const width = CaseCard.width;
        const height = CaseCard.height;
        this.outline.attr({
            x: rect.centerX(),
            y: rect.centerY() - height / 2,
            width: width,
            height: height + 70,
        });
        this.outline.toFront();
        // Update the case index
        if(caseIndex) {
            setTimeout(() => {
                this.caseCardRef?.updateCaseNo(caseIndex+1);
            }, 100);
        }
    }

    resize(newSize, inPlotBounds) {
        let Dyn = this.Dyn;
        this.bounds.copyRect(newSize);
        this.bounds.addDebugRect(this.container.paper, "red");
        Dyn.assertValidRect(this.bounds);
        this.updateVisuals();
    }

    addCase() {
        const noOfCases = this.Dyn.dataSet.getNumCasesPreFilter();
        this.caseCardRef?.updateCaseNo(noOfCases + 1);
    }

    goToCase(index) {
        this.caseCardRef?.updateCaseNo(index + 1);
    }

    hide() {
        this.Dyn.plotUtil.showOrHideElement( this.outline, false );
    }

    show() {
        this.Dyn.plotUtil.showOrHideElement( this.outline, true );
    }
}
